<template>
    <!-- ONE PAGE -->
    <div>
        <Career id="/"/>
        <Awards id="premios" />
        <Courses id="servicios"/>
        <Nominations id="nominaciones" />
        <Contact id="contacto" />
    </div>
</template>

<script>
    import Career from "./Career";
    import Awards from "./Awards";
    import Nominations from "./Nominations";
    import Courses from "./Courses";
    import Contact from "./Contact";

    export default {
        name: 'home',
        components: {Contact, Courses, Nominations, Awards, Career}
    }
</script>
<style scoped>

</style>
